<template>
  <span>
    <span v-if="isToggle">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.417"
        height="11.33"
        viewBox="0 0 18.417 11.33"
      >
        <path
          id="パス_231"
          data-name="パス 231"
          d="M1165.629,221l8.148,8.148,8.148-8.148"
          transform="translate(1182.985 231.269) rotate(180)"
          fill="none"
          stroke="#3c4b64"
          stroke-width="3"
        />
      </svg>
    </span>
    <span v-else>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.417"
        height="11.33"
        viewBox="0 0 18.417 11.33"
      >
        <path
          id="パス_231"
          data-name="パス 231"
          d="M1165.629,221l8.148,8.148,8.148-8.148"
          transform="translate(-1164.569 -219.939)"
          fill="none"
          stroke="#3c4b64"
          stroke-width="3"
        /></svg
    ></span>
  </span>
</template>
<script>
export default {
  props: {
    isToggle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
